// Copyright (c) 2026 杨翔宇（武汉文理学院）
// 物理智能教学智能体平台 (Physics Intelligent Agent)
// 保留所有权利 (All Rights Reserved)。未经著作权人书面许可，
// 不得以任何形式复制、传播、修改或用于商业用途。

import { create } from 'zustand';

import { api } from '@api/client';
import type { CommerceSettings } from '@/types/commerce';

interface CommerceState {
  settings: CommerceSettings | null;
  loading: boolean;
  loaded: boolean;
  fetchCommerceSettings: (force?: boolean) => Promise<void>;
}

export const useCommerceStore = create<CommerceState>()((set, get) => ({
  settings: null,
  loading: false,
  loaded: false,

  fetchCommerceSettings: async (force = false) => {
    if (get().loading) return;
    if (!force && get().loaded) return;

    set({ loading: true });
    try {
      const { data } = await api.getCommerceSettings();
      set({ settings: data, loading: false, loaded: true });
    } catch {
      set({ loading: false, loaded: true });
    }
  },
}));
